<form #blockInputs="ngForm">
  @if (content.contactPhoto) {
    <glxy-form-field>
      <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE' | translate }}</glxy-label>
      <div class="row row-gutters">
        <div class="image-upload-wrapper col col-xs-4">
          <glxy-image-upload-tile
            [url]="content.contactPhoto"
            [showDeleteButton]="true"
            [status]="FileUploadStatus.Queued"
            (delete)="clearImage()"
          />
        </div>
        <div class="image-controls col col-xs-8">
          <div class="image-controls-wrapper">
            <glxy-form-field [showLabel]="false" [bottomSpacing]="'small'">
              <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE_SIZE.SIZE' | translate }}</glxy-label>
              <select matInput [(ngModel)]="content.size" name="Image Size">
                <option value="small">{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE_SIZE.SMALL' | translate }}</option>
                <option value="medium">{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE_SIZE.MEDIUM' | translate }}</option>
                <option value="large">{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE_SIZE.LARGE' | translate }}</option>
              </select>
            </glxy-form-field>
            <glxy-button-group>
              <a mat-stroked-button [href]="content.contactPhoto" target="_blank" rel="noopener">View</a>
              <button mat-stroked-button (click)="clearImage()">
                {{ 'EMAIL_BUILDER.CONTACT_CARD.CLEAR_IMAGE' | translate }}
              </button>
            </glxy-button-group>
          </div>
        </div>
      </div>
    </glxy-form-field>
  } @else {
    <glxy-form-field>
      <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.IMAGE' | translate }}</glxy-label>
      <glxy-image-uploader
        #imageUploader
        [autoUpload]="true"
        [maxFiles]="1"
        [hintText]="'ADD_SOMETHING_HINT' | translate"
        (fileUploaded)="setImage($event)"
        (fileUploadErrored)="alertFileErrored($event)"
      />
    </glxy-form-field>
  }

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.NAME' | translate }}</glxy-label>
    <input
      matInput
      #name
      #nameModel="ngModel"
      sharedContainsValidDynamicContent
      [(ngModel)]="content.contactName"
      placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
      autocomplete="off"
      name="Name"
    />
    <email-dynamic-component-selector glxySuffix [target]="name" [(model)]="content.contactName" />
    @if (nameModel.hasError('invalidDynamicComponent') && nameModel.touched) {
      <glxy-error>
        {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
      </glxy-error>
    }
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.JOB' | translate }}</glxy-label>
    <input
      matInput
      #jobTitle
      #jobTitleModel="ngModel"
      sharedContainsValidDynamicContent
      [(ngModel)]="content.jobTitle"
      placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
      autocomplete="off"
      name="Job Title"
    />
    <email-dynamic-component-selector glxySuffix [target]="jobTitle" [(model)]="content.jobTitle" />
    @if (jobTitleModel.hasError('invalidDynamicComponent') && jobTitleModel.touched) {
      <glxy-error>
        {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
      </glxy-error>
    }
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.CONTACT_CARD.ADDITIONAL_INFO' | translate }}</glxy-label>

    @for (item of content.additionalInfo; track fixFieldLosingFocusWhenTyping(i, item); let i = $index) {
      <div class="additional-item">
        <div class="input-wrapper">
          <input
            style="display: block"
            matInput
            #additionalInfo
            #additionalInfoModel="ngModel"
            sharedContainsValidDynamicContent
            [(ngModel)]="content.additionalInfo[i]"
            placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
            autocomplete="off"
            name="additional-info-{{ i }}"
          />
          <email-dynamic-component-selector
            glxySuffix
            [target]="additionalInfo"
            [(model)]="content.additionalInfo[i]"
          />
        </div>
        <button
          mat-icon-button
          class="additional-item-remove"
          (click)="removeAdditionalItem(i)"
          [matTooltip]="'EMAIL_BUILDER.CONTACT_CARD.REMOVE_ROW' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @if (additionalInfoModel.hasError('invalidDynamicComponent') && additionalInfoModel.touched) {
        <div>
          <glxy-error>
            {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
          </glxy-error>
        </div>
      }
    }
    <button class="add-additional-item-button" mat-stroked-button (click)="addAdditionalItem()">
      {{ 'EMAIL_BUILDER.CONTACT_CARD.ADD_ROW' | translate }}
    </button>
  </glxy-form-field>
</form>
